import Comm from '../services/comm';

export default{
    namespaced: true,
    state: {
        eventStatusLoading: false,
        eventStatusError: null,
        deviceTypeLoading: false,
        deviceTypeError: null
    },
    actions: {
        getEventStatuses(context, data){
            context.state.eventStatusError = null;
            context.state.eventStatusLoading = true;
            Comm.getData('eventstatus.php').then(
                res => {
                    data.result(res.data);
                    context.state.eventStatusLoading = false;
                },
                rej => {
                    data.reject(rej);
                    context.state.eventStatusLoading = false;
                    context.eventStatusError = "Hiba történt a munkalap státuszok betöltése közben.";
                }
            )
        },
        getDeviceTypes(context, data){
            context.state.deviceTypeError = null;
            context.state.deviceTypeLoading = true;
            Comm.getData('devicetypes.php').then(
                res => {
                    data.result(res.data);
                    context.state.deviceTypeLoading = false;
                },
                rej => {
                    data.reject(rej);
                    context.state.deviceTypeLoading = false;
                    context.deviceTypeError = "Hiba történt a munkalap státuszok betöltése közben.";
                }
            )
        }
    },
}



// WEBPACK FOOTER //
// ./src/store/helperStore.js